import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0F172A] border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold tracking-tighter uppercase mb-4">
              <span className="text-[#00A6E8]">FALLOU</span>
              <span className="text-[#FFA726] ml-2">ENTERPRISE</span>
            </h3>
            <p className="text-slate-400 text-sm">dba DLT</p>
            <p className="text-slate-400 text-sm mt-2">Based in Columbus, Ohio</p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Contact</h4>
            <div className="space-y-3 text-slate-400 text-sm">
              <div className="flex items-center gap-2">
                <Phone size={16} className="text-[#00A6E8]" />
                <span>Office: +1 (614) 778 8307</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} className="text-[#00A6E8]" />
                <span>Mobile: +1 (614) 598 6668</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} className="text-[#00A6E8]" />
                <span>mdiouf@fallouenterprise.com</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Credentials</h4>
            <div className="space-y-2 text-slate-400 text-sm">
              <p><span className="text-[#FFA726] font-semibold">US DOT:</span> 1662372</p>
              <p><span className="text-[#FFA726] font-semibold">MC:</span> 657445</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Fallou Enterprise INC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};